import { InviteToShareStoryMeta, InviteToShareStoryPayload } from 'types/store/InviteToShareStory';
import { createAsyncReducer } from 'utils/Redux';

import { inviteToShareStoryActions } from '../actions';

export default createAsyncReducer<InviteToShareStoryMeta, InviteToShareStoryPayload>(inviteToShareStoryActions);
